import { postTokenRefresh } from '~/api/token/refresh';
import { useRequestApi } from '~/hooks/useRequestApi';

export const useTokenApi = () => {
  const postTokenRefreshRequest = useRequestApi(postTokenRefresh, (res) => res);

  return { postTokenRefreshRequest };
};
